export const rootClassName = 'satellite_tabs'

type Component = 'tab' | 'list' | 'panel'

const components: { [key in Component]: string } = {
  tab: 'tab',
  list: 'tab-list',
  panel: 'panel',
}

export const getComponentClassName: (arg: Component) => string = (component) =>
  `${rootClassName}__${components[component]}`
